import React, { useEffect, useState } from "react";
import { IconType } from "react-icons";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { FaUser } from "react-icons/fa";
import { RxLapTimer } from "react-icons/rx";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import StudentSideBarLayout from "../StudentSideBarLayout/StudentSideBarLayout";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { useGetAllStudentDataQuery } from "src/services/StudentService";

type Props = {};

export const StudentTabs: {
  label: string;
  icon: IconType;
  path: string;
  moduleName?: string;
  actionName?: string;
}[] = [
    {
      label: "Orders",
      icon: FaUser,
      path: "order",
    },
    {
      label: "Ledger",
      icon: RxLapTimer,
      path: "ledger",
    },
  ];

const StudentTicketViewLayout = (props: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.split("/")[3];
  const [sidebarListTotalItems, setSidebarListTotalItems] = useState<number>(0);
  const [searchValue, setSearchValue] = useState<string>("");
  const [limit, setLimit] = useState<number>(10);

  const {
    page,
    rowsPerPage,
  } = useSelector((state: RootState) => state.student);
  const [sidebarList, setSidebarList] = useState<any[]>([]);

  const { data, isLoading, isFetching } = useGetAllStudentDataQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: [
      "name",
      "mobile",
    ],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setSidebarList(data?.data);
      setSidebarListTotalItems(data?.totalItem || 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);
  return (
    <>
      <SideNavLayout>
        <div className="flex flex-col h-full">
          <div className="flex  gap-2 border-b">
            <div className="">
              <StudentSideBarLayout
                hideViewMore={sidebarListTotalItems > limit ? true : false}
                listData={sidebarList}
                searchValue={searchValue}
                onSearch={(value: any) => {
                  setSearchValue(value);
                }}
                loader={isLoading || isFetching}
                onClickViewMore={() => setLimit(limit + 10)}
                onClickChangeRequestView={(studentId) => {
                  navigate(`/student/${studentId}/order`);
                }}
              />
            </div>
            <div className="w-full flex flex-col h-[calc(100vh-50px)]">

              {/* StudentTabs */}
              {StudentTabs?.length && (
                <div className="flex gap-3 items-center bg-white ">
                  {StudentTabs?.map((tab: any, index: any) => {
                    return (
                      <div key={index}>
                        <button
                          type="button"
                          onClick={() => navigate(tab.path)}
                          className={`h-full px-4 pb-2 flex gap-2 border-b-[3px] items-center hover:text-primary-main font-medium text-sm transition-all
                      ${currentPath === tab.path?.split("/")[0]
                              ? "text-primary-main  border-primary-main"
                              : "text-gray-700 border-white"
                            }
                      `}
                        >
                          <div className="text-sm">
                            <tab.icon />
                          </div>
                          {tab.label}
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}

              <div className="grow overflow-auto bg-gray-50">
                <Outlet />
              </div>
            </div>

          </div>


        </div>
      </SideNavLayout>
    </>
  );
};

export default StudentTicketViewLayout;
